import {getMomentDate} from '../utils/commonUtils';
import { PAGINATION } from '../constants/Define';
import moment from 'moment';

export default class VoucherRedeemtion {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.groupId = data.groupId || undefined;
        this.groupName = data.groupName || undefined;
        this.properties = data.properties || undefined;
        this.saleStartDate = getMomentDate(data.saleStartDate);
        this.saleEndDate = getMomentDate(data.saleEndDate);
        this.originalPrice = data.originalPrice || 0;
        this.salePrice = data.salePrice || 0;
        this.openingStock = data.openingStock || 0;
        this.increase = data.increase || 0;
        this.decrease = data.decrease || 0;
        this.usedCount = data.usedCount || 0;
        this.closingStock = data.closingStock || 0;
        this.setDetail(data.detail || {});
    }

    setDetail(data={}){
        this.detail = {
            pageIndex: data.pageIndex || PAGINATION.pageIndex,
            pageSize: data.pageSize || PAGINATION.pageSize,
            totalCount: data.totalCount || 0,
            totalPage: Math.ceil(parseInt(data.totalCount || 0) / parseInt(data.pageSize || PAGINATION.pageSize)),
            startDate: data.startDate ? moment.utc(data.startDate) : moment.utc().startOf('isoWeeks'),
            endDate: data.startDate ? moment.utc(data.endDate) : moment.utc().endOf('days'),
            orderBy: data.orderBy,
            orderByDesc: data.orderByDesc,
            items: (data.result || data.items || []).map(item => new VoucherRedeemtionDetail(item))
        }
    }

}

export class VoucherRedeemtionDetail {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.propertyId = data.propertyId || undefined;
        this.propertyName = data.propertyName || undefined;
        this.usedCount = data.usedCount || 0;
    }
}
